(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

export default class Cache {
  constructor(expireTime) {
    this.expireTime = expireTime;
    this.data = {};
    this.timers = {};
  }

  get(key) {
    return this.data[key];
  }

  add(key, data) {
    this.clearTimer(key);
    this.data[key] = data;

    if (typeof this.expireTime === "number") {
      this.timers[key] = setTimeout(() => {
        delete this.data[key];
      }, this.expireTime);
    }
  }

  delete(key) {
    this.clearTimer(key);
    delete this.data[key];
  }

  clearTimer(key) {
    if (this.timers[key]) {
      clearTimeout(this.timers[key]);
      delete this.timers[key];
    }
  }

  getKeys() {
    return Object.keys(this.data);
  }

  clean() {
    Object.values(this.timers).forEach(timer => clearTimeout(timer));
    this.data = {};
    this.timers = {};
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Cache, "Cache", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/cache/cache.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();